









import { Component, Vue, Prop } from 'vue-property-decorator';
import Header from '@/components/ElementComponent/Header/index.vue';
import Sidebar from '@/components/ElementComponent/Sidebar/index.vue';

@Component<App>({
    name: 'App',
    components: {
        Header,
        Sidebar,
    },
})
export default class App extends Vue {
    @Prop({type: Boolean, default: false}) private alertIsOn!: boolean;
    private customerInfo: boolean = false;
    get header(): boolean {
        return this.$route.meta.header;
    }

    get nav(): boolean {
        return this.$route.meta.nav;
    }

}
